module.exports = [
  ...require('./_magicItemRawList_DMG_a'),
  require('./alchemy_jug'),
  require('./arrow_of_slaying'),
  require('./axe_of_the_dwarvish_lords'),
]
